module.exports = __webpack_public_path__ + "img/feature_buy_bonus_zh.5a2e0515.png";